import isJestTest from '../data/is-jest-test';

/**
 * @function consoleError
 * @description Logs console errors if console is available and we arent running Jest
 *
 * @param message
 */

export default function consoleError( message = '' ) {
	if( window.console && ! isJestTest() ) {
		console.error( message );
	}
}
